<template>
    <div>
        <div class="clearfix pb-4 pt-4">
            <h1>{{ model.fullname }}</h1>
        </div>
        <div class="row">
            <div class="col-md-6">
                <ul class="list-unstyled list-key-value">
                    <li>
                        <span class="key">{{ $t("brand") }}:</span>
                        <span class="value">{{ model.brand.name }}</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("model") }}:</span>
                        <span class="value">{{ model.fullname }}</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("length_overall") }}:</span>
                        <span class="value">{{ model.length_overall }} m</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("length_hull") }}:</span>
                        <span class="value">{{ model.length_hull }} m</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("beam_max") }}:</span>
                        <span class="value">{{ model.beam_max }} m</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("draft") }}:</span>
                        <span class="value">{{ model.draft }} m</span>
                    </li>
                </ul>
            </div>
            <div class="col-md-6">
                <ul class="list-unstyled list-key-value">
                    <li>
                        <span class="key">{{ $t("dry_weight") }}:</span>
                        <span class="value">{{ model.dry_weight }} kg</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("engines_number") }}:</span>
                        <span class="value">{{ model.engines_number }}</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("passengers_weight") }}:</span>
                        <span class="value"
                            >{{ model.passengers_weight }} kg</span
                        >
                    </li>
                    <li>
                        <span class="key">{{ $t("fuel_capacity") }}:</span>
                        <span class="value">{{ model.fuel_capacity }} l</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("water_capacity") }}:</span>
                        <span class="value">{{ model.water_capacity }} l</span>
                    </li>
                    <li>
                        <span class="key">{{ $t("design_category") }}:</span>
                        <span class="value">{{
                            model.design_category.name
                        }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.list-key-value {
    font-size: 1.1rem;
    .key {
        margin-right: 0.25rem;
        font-weight: 100;
    }
    .value {
        font-weight: bold;
    }
}
</style>

<script>
export default {
    props: {
        model: {
            type: Object,
            required: true,
        },
    },
};
</script>
